var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.044-46.2a2.865,2.865,0,0,0,2.609-2.171l8.9-23.345a4.131,4.131,0,0,0,.3-1.447A1.917,1.917,0,0,0,32.823-75.2a4.059,4.059,0,0,0-1.447.3L8-65.972A2.836,2.836,0,0,0,5.859-63.38c0,1.431,1.01,2.1,2.424,2.558l5.756,1.784a2.56,2.56,0,0,0,2.912-.438L32.4-73.411a.5.5,0,0,1,.69-.017.5.5,0,0,1-.017.69L19.156-57.321a2.778,2.778,0,0,0-.488,2.929l1.8,5.723C20.906-47.239,21.613-46.2,23.044-46.2Z",
    transform: "translate(-5.859 75.195)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.34991752eeea39d0301dedd3ae4cf47f.svg";
export { ForwardRef as ReactComponent };